module.exports = __webpack_public_path__ + "img/logo.cace85b5.png";